export default {
    linguagem: 'pt',
    compraDireta: {},
    itensELotes: {
        itens: [],
        lotes: []
    },
    resumoProposta: {
        consulta: null,
        criadoEm: null,
        dataHoraEncerramento: null,
        disputaPor: null,
        exibeValorReferencia: null,
        id: null,
        idProtocoloVirtualizado: null,
        isProtocoloAssinado: null,
        numeroProtocolo: null,
        objeto: null,
        orgao: null,
        processo: null,
        propostaEnviada: null,
        propostaId: null,
        quantidadeRepeticoes: null,
        situacao: null,
        situacaoProposta: null,
        tempoRandomico: null,
        tempoRandomicoLance: null,
        tipo: null,
        uriProtocolo: null,
        urlProtocoloVirtualizado: null
    },
    documentosProposta: [],
    linhasFornecimento: [],
    documentosSolicitados: []
}
